import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';
import {getFeatureFlagValue} from 'infra/http/utils/get-feature-flag-value';
import {FeaturesEnum} from 'presentation/constants';
import {GetExamsDistricts} from 'domain/usecases/private/booking-flow/exams/get-exams-districts';
import {RemoteGetExamsDistricts} from 'data/usecases/private/booking-flow/exams/remote-get-exams-districts';

export const makeGetExamsDistricts = (): GetExamsDistricts => {
	const isExamsLocationsNeighborhoodsV3Enabled = getFeatureFlagValue(
		FeaturesEnum.PORTAL_FEATURE_EXAMS_LOCATIONS_NEIGHBORHOODS_V3,
	);

	const endpoint = isExamsLocationsNeighborhoodsV3Enabled
		? BookingFlowEndPoints.examDistrictsV3
		: BookingFlowEndPoints.examDistricts;

	return new RemoteGetExamsDistricts(makeBFFApiUrl(endpoint), makeAuthorizeHttpClientDecorator());
};
